import * as React from "react";
import { cn } from "@/lib/utils";

const JeaInput = React.forwardRef(
  ({ className, type = "text", leftIcon = null, rightSlot = null, error = false, ...props }, ref) => {
    return (
      <div
        className={cn(
          "relative flex items-center w-full rounded-[8px] bg-bg-tertiary border transition-all duration-200 ease-smooth",
          error ? "border-danger" : "border-border-default",
          "focus-within:border-accent-pink focus-within:shadow-pink-glow"
        )}
      >
        {leftIcon && (
          <span className="pl-3 text-text-secondary flex items-center">{leftIcon}</span>
        )}
        <input
          ref={ref}
          type={type}
          className={cn(
            "flex-1 h-11 bg-transparent text-[14px] text-white placeholder:text-text-muted focus:outline-none",
            leftIcon ? "pl-2 pr-3" : "px-3",
            className
          )}
          {...props}
        />
        {rightSlot && <span className="pr-2 flex items-center">{rightSlot}</span>}
      </div>
    );
  }
);
JeaInput.displayName = "JeaInput";

export { JeaInput };
export default JeaInput;
